export default "__VITE_PUBLIC_ASSET__624267aa__"